export enum MeetingType {
  // Not really supported ATM
  Consult = 'Consult',
  FollowUpSession = 'Follow-up Session',
  InitialConsultation = 'Initial Consultation',
  InitialCoachCall = 'Initial Coach Call',
}

export type MeetingInfo = {
  id: string;
  length: number;
  name: MeetingType;
};

export type AvailabilityEntry = {
  date: string;
  times: string[]; // ISO strings
};
